module.exports = __webpack_public_path__ + "static/media/imm_image.ab8e1c7d.png";